import React from 'react';

export default function ComingSoon() {
  return (
    <div className="text-center">
      <h2 className="text-xl font-semibold mb-2 text-[var(--mudo-text)]">Mudo Adventure</h2>
      <p className="text-[var(--mudo-text-muted)]">Coming soon.</p>
    </div>
  );
}